var config = module.exports = {};

config.stoplossType = {
    StoplossTypeATR : 1,
    StoplossTypeQuote : 2,
    StoplossTypePercent : 3,
    StoplossTypeSMA20 : 4,
    StoplossTypeSMA50 : 5    
}

config.rates = {
	rateUSD : 1,
	rateCAD : 1,
	rateEUR : 1
}

config.IP = "98.128.130.56:3000";